import React from 'react';
import PropTypes from 'prop-types';
import Block from '../../../block/Block';
import styles from './Divider.less';
export var Divider = function Divider() {
  return /*#__PURE__*/React.createElement(Block, {
    el: "hr",
    className: styles['content-divider'],
    "data-en": 'cms-divider'
  });
};
Divider.propTypes = {
  data: PropTypes.object.isRequired
};
export default Divider;